<template>
  <div
    class="dark-brand-logo"
    :class="{ 'dark-brand-logo--compact': compact }"
    role="img"
    aria-label="On the Clock Now"
  >
    <img
      class="dark-brand-logo__mark"
      src="../assets/logo.png"
      alt=""
    />
    <span class="dark-brand-logo__words">
      <span class="dark-brand-logo__top">On the</span>
      <span class="dark-brand-logo__bottom">Clock Now</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "DarkBrandLogo",
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.dark-brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  color: #fff;
  user-select: none;
  -webkit-user-select: none;
}

.dark-brand-logo__mark {
  display: block;
  width: 66px;
  height: 66px;
  object-fit: contain;
}

.dark-brand-logo__words {
  display: flex;
  flex-direction: column;
  font-weight: 850;
  letter-spacing: 0.035em;
  line-height: 0.94;
  text-transform: uppercase;
}

.dark-brand-logo__top {
  color: #f8fafc;
  font-size: 25px;
}

.dark-brand-logo__bottom {
  margin-top: 5px;
  color: #15c4d4;
  font-size: 25px;
}

.dark-brand-logo--compact {
  gap: 7px;
}

.dark-brand-logo--compact .dark-brand-logo__mark {
  width: 42px;
  height: 42px;
}

.dark-brand-logo--compact .dark-brand-logo__top,
.dark-brand-logo--compact .dark-brand-logo__bottom {
  font-size: 14px;
}

.dark-brand-logo--compact .dark-brand-logo__bottom {
  margin-top: 3px;
}
</style>
